import * as React from 'react'

import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface ResetModalProps {
  closeModal: any,
  reset: any
}

const ResetModal = ({ closeModal, reset, }: ResetModalProps) => {
  const { modalRef } = useModalAccessibility(closeModal);

  return (
    <div
      aria-labelledby='title'
      aria-live="polite"
      aria-modal={true}
      className="reset-modal-container"
      ref={modalRef}
      role="dialog"
      tabIndex={-1}
    >
      <div className="reset-modal-background" />
      <div className="reset-modal">
        <div className="top-section">
          <ReadAloudContent label="Read the message aloud">
            <h1 id="title">Reset the passage?</h1>
            <p>This will undo all the edits you made and reset the passage to its original state.</p>
          </ReadAloudContent>
        </div>
        <div className="button-section">
          <button className="quill-button medium secondary outlined focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <button className="quill-button medium primary contained focus-on-light" onClick={reset} type="button">Reset passage</button>
        </div>
      </div>
    </div>
  )
}

export default ResetModal
